/**
 * Module summary:
 * Shared catalog defaults for the current assessment rollout so creation,
 * loading, and migration logic use one consistent active assessment id.
 */

export const ACTIVE_ASSESSMENT_ID = 'facility-security-v2';
export const ACTIVE_ASSESSMENT_VERSION = '2.1.0';
export const ACTIVE_ASSESSMENT_TITLE = 'Facility Security & Readiness Assessment';
